import React from 'react';
import Icon from '../../../components/AppIcon';

const NotificationPanel = ({ notifications }) => {
  const getNotificationIcon = (type) => {
    switch (type) {
      case 'view': return 'Eye';
      case 'unlock': return 'Unlock';
      case 'message': return 'MessageCircle';
      case 'match': return 'Heart';
      default: return 'Bell';
    }
  };

  const getNotificationColor = (type) => {
    switch (type) {
      case 'view': return 'primary';
      case 'unlock': return 'success';
      case 'message': return 'accent';
      case 'match': return 'destructive';
      default: return 'muted-foreground';
    }
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const time = new Date(timestamp);
    const diffInMinutes = Math.floor((now - time) / (1000 * 60));
    
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
    return `${Math.floor(diffInMinutes / 1440)}d ago`;
  };

  return (
    <div className="bg-card rounded-xl shadow-elevation border border-border">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-foreground">Recent Activity</h3>
          <div className="flex items-center space-x-1 text-sm text-muted-foreground">
            <Icon name="Bell" size={16} />
            <span>{notifications?.length}</span>
          </div>
        </div>
      </div>
      <div className="max-h-80 overflow-y-auto">
        {notifications?.length === 0 ? (
          <div className="p-6 text-center">
            <Icon name="Bell" size={48} className="mx-auto mb-3 text-muted-foreground/50" />
            <p className="text-muted-foreground">No recent activity</p>
          </div>
        ) : (
          <div className="divide-y divide-border">
            {notifications?.map((notification) => (
              <div key={notification?.id} className="p-4 hover:bg-muted/30 transition-colors">
                <div className="flex items-start space-x-3">
                  <div className={`h-8 w-8 rounded-full bg-${getNotificationColor(notification?.type)}/10 flex items-center justify-center flex-shrink-0`}>
                    <Icon 
                      name={getNotificationIcon(notification?.type)} 
                      size={16} 
                      className={`text-${getNotificationColor(notification?.type)}`} 
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground">
                      {notification?.title}
                    </p>
                    <p className="text-sm text-muted-foreground mt-1">
                      {notification?.message}
                    </p>
                    <p className="text-xs text-muted-foreground mt-2">
                      {formatTimeAgo(notification?.timestamp)}
                    </p>
                  </div>
                  {!notification?.read && (
                    <div className="h-2 w-2 bg-primary rounded-full flex-shrink-0" />
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationPanel;